/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import { Button, Modal } from '@patternfly/react-core';
import React, { FunctionComponent } from 'react';

export type CloseCallback = () => void;

export interface IAboutDialogProps {
  title: string;
  onClose: CloseCallback;
  isOpen: boolean;
  uiVersion: string;
  runtimeVersion: string;
}

export const AboutDialog: FunctionComponent<IAboutDialogProps> = ({
  title,
  onClose,
  isOpen,
  uiVersion,
  runtimeVersion,
}) => {
  return (
    <Modal
      variant="small"
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      actions={[
        <Button
          key={'close'}
          variant={'primary'}
          onClick={onClose}
          aria-label="Close"
          data-testid={'about-dialog-close-button'}
          isDisabled={!onClose}
        >
          Close
        </Button>,
      ]}
    >
      <div>UI Version: {uiVersion}</div>
      <div>Runtime Version: {runtimeVersion}</div>
    </Modal>
  );
};
